document.addEventListener('DOMContentLoaded', function() {
// Select all links in the element with ID #Details-menu-drawer-container with href starting with '#'
  var headerDrawerLinks = document.querySelectorAll('#Details-menu-drawer-container a[href^="#"]');

  // Function to close the menu drawer
  function closeMenuDrawer() {
    var menuDrawer = document.querySelector('#Details-menu-drawer-container');
    if (menuDrawer) {
      // Remove the 'open' attribute
      menuDrawer.removeAttribute('open');
      // Remove the 'menu-opening' class
      menuDrawer.classList.remove('menu-opening');

      // Find the <summary> tag and set aria-expanded to false
      var summaryTag = menuDrawer.querySelector('summary');
      if (summaryTag) {
        summaryTag.setAttribute('aria-expanded', 'false');
      }
    }

    // Remove the overflow-hidden-tablet class from the body
    document.body.classList.remove('overflow-hidden-tablet');

    // Optional: If there's a backdrop or overlay, hide it
    var backdrop = document.querySelector('.header-drawer-backdrop');
    if (backdrop) {
      backdrop.classList.remove('is-visible');
    }
  }

  // Add click event listener to each link
  headerDrawerLinks?.forEach(function (link) {
    link.addEventListener('click', function () {
      closeMenuDrawer();
    });
  });

  $(document).ready(function(){
    $('.client-slider').slick({
      //dots: true,
      infinite: true,
      speed: 2000,
      slidesToShow: 5.5,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      cssEase: 'linear',
      arrows: false,
      swipe: false,
      responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
            }
          },
          {
            breakpoint: 992, 
            settings: {
              slidesToShow: 3, 
              autoplay: true,
              autoplaySpeed: 0,
              infinite: true,
              speed: 8000,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              autoplay: true,
              autoplaySpeed: 0,
              infinite: true,
              speed: 8000,
            }
          },
         {
            breakpoint: 320,
            settings: {
              slidesToShow: 1.5,
            }
          }
        ]
    });
    $('.image-slider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      cssEase: 'linear',
      arrows: false,
      centerMode: true,
      swipe: false,
      responsive: [
          {
            breakpoint: 1024, 
            settings: {
              slidesToShow: 2, 
              autoplay: true,
              autoplaySpeed: 0,
              infinite: true,
              speed: 8000,
            }
          },
          {
            breakpoint: 540,
            settings: {
              slidesToShow: 1,
              autoplay: true,
              autoplaySpeed: 0,
              infinite: true,
              speed: 8000,
            }
          }
        ]
    });
    $('.instagram-posts').slick({
      //dots: true,
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      cssEase: 'linear',
      arrows: false,
      swipe: false,
      responsive: [
          {
            breakpoint: 992, 
            settings: {
              slidesToShow: 2, 
              autoplay: true,
              autoplaySpeed: 0,
              infinite: true,
              speed: 8000,
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1,
              autoplay: true,
              autoplaySpeed: 0,
              infinite: true,
              speed: 8000,
            }
          }
        ]
    });
    $('.client-reviews-slider').slick({
      //dots: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed:2000,
      // speed: 8000,
      cssEase: 'linear',
      arrows: false,
      responsive: [
          {
            breakpoint: 1024, 
            settings: {
              slidesToShow: 1, 
              autoplay: true,
              autoplaySpeed: 0,
              infinite: true,
              speed: 8000,
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1,
              autoplay: true,
              autoplaySpeed: 0,
              infinite: true,
              speed: 8000,
            }
          }
        ]
    });

    $('.missed-slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow: '<button type="button" class="slick-prev"><img src="https://asterley-bros-cws.myshopify.com/cdn/shop/t/2/assets/arrow-next_small.png?v=58257649954789432181724161106" width="18" height="32" alt="Previous"></button>',
      nextArrow: '<button type="button" class="slick-next"><img src="https://asterley-bros-cws.myshopify.com/cdn/shop/t/2/assets/arrow-next_small.png?v=58257649954789432181724161106"  width="18" height="32" alt="Next"></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    
  });
                  

});

